const viewerPluginNames = [
  "actionButton",
  "audio",
  "codeBlock",
  "collapsibleList",
  "divider",
  "file",
  "gallery",
  "giphy",
  "hashtag",
  "html",
  "toc",
  "image",
  "link",
  "linkButton",
  "linkPreview",
  "mentions",
  "poll",
  "smartBlock",
  "spoiler",
  "table",
  "textColor",
  "textHighlight",
  "verticalEmbed",
  "video",
  "fontFamily",
  "shape",
  "card",
  "smartBlock"
];
const editorPluginNames = [
  "ai",
  "inlineAi",
  "layout",
  "emoji",
  "heading",
  "indent",
  "lineSpacing",
  "card",
  ...viewerPluginNames
];
const nextPluginToLegacyMap = {
  fontFamily: "fontFamily",
  ai: "wix-rich-content-plugin-ai",
  inlineAi: "inlineAi",
  emoji: "wix-draft-plugin-emoji",
  heading: "wix-rich-content-plugin-headings",
  indent: "wix-rich-content-plugin-indent",
  lineSpacing: "line-spacing",
  actionButton: "wix-draft-plugin-action-button",
  audio: "ricos-audio",
  codeBlock: "code-block",
  collapsibleList: "wix-rich-content-plugin-collapsible-list",
  divider: "wix-draft-plugin-divider",
  file: "wix-draft-plugin-file-upload",
  gallery: "wix-draft-plugin-gallery",
  giphy: "wix-draft-plugin-giphy",
  hashtag: "wix-draft-plugin-hashtag",
  html: "wix-draft-plugin-html",
  toc: "toc",
  image: "wix-draft-plugin-image",
  link: "LINK",
  linkButton: "wix-draft-plugin-link-button",
  linkPreview: "wix-draft-plugin-link-preview",
  mentions: "wix-draft-plugin-external-mentions",
  poll: "wix-draft-plugin-poll",
  spoiler: "wix-rich-content-plugin-spoiler",
  table: "wix-rich-content-plugin-table",
  textColor: "wix-rich-content-text-color",
  textHighlight: "wix-rich-content-text-highlight",
  verticalEmbed: "wix-draft-plugin-vertical-embed",
  video: "wix-draft-plugin-video",
  layout: "layout",
  shape: "shape",
  card: "card",
  smartBlock: "smart-block"
};
const legacyPluginToNextMap = Object.fromEntries(
  Object.entries(nextPluginToLegacyMap).map(([key, value]) => [value, key])
);
const toEditorPluginName = (pluginType) => {
  if (editorPluginNames.includes(pluginType)) {
    return pluginType;
  }
  return legacyPluginToNextMap[pluginType];
};
export {
  editorPluginNames,
  legacyPluginToNextMap,
  toEditorPluginName,
  viewerPluginNames
};
//# sourceMappingURL=plugin-names.js.map
